import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container global-achievements-class" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.achievements')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.achievements, (a) => {
        return (_openBlock(), _createElementBlock("article", {
          key: a.text
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ic, { icon: "star" }),
              _createElementVNode("div", {
                class: "name",
                innerHTML: a.text
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", {
              class: "year",
              innerHTML: a.year
            }, null, 8, _hoisted_6)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}